import { render, staticRenderFns } from "./ConsultarConvenios.vue?vue&type=template&id=1d57910b&scoped=true"
import script from "./ConsultarConvenios.vue?vue&type=script&lang=ts"
export * from "./ConsultarConvenios.vue?vue&type=script&lang=ts"
import style0 from "./ConsultarConvenios.vue?vue&type=style&index=0&id=1d57910b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d57910b",
  null
  
)

export default component.exports